"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateReportingOutputConfig = void 0;
const common_1 = require("@finley-technologies/common");
const outputDocxConfigValidate_1 = require("./outputDocxConfigValidate");
const outputXlsxConfigValidate_1 = require("./outputXlsxConfigValidate");
const validateReportingOutputConfig = (params) => {
    const { config } = params;
    const { type } = config;
    switch (type) {
        case 'xlsx':
            return (0, outputXlsxConfigValidate_1.validateReportingOutputXlsxConfig)({ config: config.output });
        case 'docx':
            return (0, outputDocxConfigValidate_1.validateReportingOutputDocxConfig)({ config: config.output });
        case 'digital':
            return []; // digital has no output config
        default:
            return (0, common_1.finleyAssertUnreachable)(type);
    }
};
exports.validateReportingOutputConfig = validateReportingOutputConfig;
//# sourceMappingURL=outputConfigValidate.js.map